import type {OrderFilter, OrderUrlFilters} from './types';
import type {UrlFilterSchema} from '@router';

export const ORDER_PAGE_SIZE = 6;

export const ORDER_FILTER_SCHEMA: UrlFilterSchema<OrderUrlFilters> = {
  start_date: 'string',
  end_date: 'string',
  is_modified: 'boolean',
  coupon: 'array',
  expedition_type: 'array',
  order_status: 'array'
};

export const createOrderFilters = (): OrderFilter[] => {
  const today = new Date();
  const toDate = (date: Date) => date.toISOString().split('T')[0];
  const daysAgo = (days: number) => toDate(new Date(today.getTime() - days * 24 * 60 * 60 * 1000));

  return [
    {
      title: 'تاریخ به صورت بازه',
      type: 'custom',
      name: 'date',
      items: [
        {
          key: 'yesterday',
          title: 'دیروز',
          value: '1',
          selected: false,
          date: {start_date: daysAgo(1), end_date: daysAgo(1)}
        },
        {
          key: 'week',
          title: 'یک هفته گذشته',
          value: '7',
          selected: false,
          date: {start_date: daysAgo(7), end_date: toDate(today)}
        },
        {
          key: 'month',
          title: 'سی روز گذشته',
          value: '30',
          selected: false,
          date: {start_date: daysAgo(30), end_date: toDate(today)}
        },
        {
          key: 'customDate',
          title: 'تاریخ دلخواه (تا ۹۰ روز گذشته)',
          value: '0',
          selected: false,
          date: {start_date: null, end_date: null}
        }
      ]
    },
    {title: 'اصلاح شده', name: 'is_modified', type: 'selectable', selected: false},
    {
      name: 'coupon',
      title: 'کوپن',
      type: 'multiSelectable',
      items: [
        {key: 'ارسال رایگان', title: 'ارسال رایگان', value: 'free_delivery_fee', selected: false},
        {key: 'محصول هدیه', title: 'محصول هدیه', value: 'extra_item', selected: false},
        {key: 'تخفیف کالایی', title: 'تخفیف کالایی', value: 'total_discount', selected: false}
      ]
    },
    {
      name: 'expedition_type',
      title: 'روش ارسال',
      type: 'multiSelectable',
      items: [
        {key: 'پیک اکسپرس', title: 'پیک اکسپرس', value: 'ZF_EXPRESS', selected: false},
        {key: 'تحویل حضوری', title: 'تحویل حضوری', value: 'PICKUP', selected: false},
        {key: 'پیک فروشگاه', title: 'پیک فروشگاه', value: 'DELIVERY', selected: false}
      ]
    },
    {
      name: 'order_status',
      title: 'وضعیت سفارش',
      type: 'multiSelectable',
      items: [
        {key: 'تایید شده', title: 'تایید شده', value: 'accept', selected: false},
        {key: 'لغو شده', title: 'لغو شده', value: 'declined', selected: false},
        {key: 'منتظر تایید', title: 'منتظر تایید', value: 'vendor_pending', selected: false},
        {key: 'نیازمند تماس', title: 'نیازمند تماس', value: 'needforcall', selected: false}
      ]
    }
  ];
};
